import { Stack, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useState } from 'react';

interface CampaignIdCellProps {
    campaignId?: string | number | null | undefined;
}

export const CampaignIdCell = ({ campaignId }: CampaignIdCellProps) => {
    const [copiedId, setCopiedId] = useState<string | null>(null);

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (campaignId) {
            const campaignIdStr = String(campaignId);
            navigator.clipboard.writeText(campaignIdStr);
            setCopiedId(campaignIdStr);
            setTimeout(() => setCopiedId(null), 2000);
        }
    };

    if (!campaignId) return null;

    const campaignIdStr = String(campaignId);

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography
                variant="body2"
                sx={{
                    fontFamily: 'monospace',
                    fontWeight: 500,
                    fontSize: '0.75rem'
                }}
            >
                {campaignIdStr}
            </Typography>
            <Tooltip title={copiedId === campaignIdStr ? "Copied!" : "Copy Campaign ID"}>
                <IconButton
                    size="small"
                    onClick={handleCopy}
                    color={copiedId === campaignIdStr ? "success" : "default"}
                >
                    <ContentCopyIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </Stack>
    );
}; 